"use client";

import { Box, Image } from "@chakra-ui/react";

interface TravelHeroProps {
  src: string;
  alt: string;
  gradient?: string;
}

const DEFAULT_GRADIENT = "linear-gradient(180deg, #a8d4f0 0%, #c5e4f5 100%)";

const TravelHero = ({
  src,
  alt,
  gradient = DEFAULT_GRADIENT,
}: TravelHeroProps) => (
  <Box
    position="relative"
    w="full"
    h={{ base: "180px", md: "260px", lg: "320px" }}
    flexShrink={0}
    bg={gradient}
    overflow="hidden"
  >
    <Image
      src={src}
      alt={alt}
      w="full"
      h="full"
      objectFit="cover"
      objectPosition="center 30%"
    />
  </Box>
);

export default TravelHero;
